// removed by extract-text-webpack-plugin
module.exports = {"scroll":"_2JfG8jzD2usfm7jLQaayps","holyGrail":"_25aZDa7IhJCk9vviBWZCQ7","stretch":"JaqZQbUo73CHJ2axu5RUR","header":"_1fTs-IwCwPVGh933N_cCv3","footer":"_2jmv0Bw3M0HLuTrCATfamE","ieWrap":"_3KC2mDxTXYoUJBQIfUaPQz","body":"j9GMESmS-Uolvp2s0DlnF","content":"_2ShahRFQg5v9HCl32ItO_Z","nav":"jFzRMMIxIbtZBZCCMeGDV","aside":"_21vGu_YUCF3EM5-KEODkkP","screenResizer":"_22ZUH4ppcDyCx53aMPqLjf"};


//////////////////
// WEBPACK FOOTER
// ./elements/grail.scss
// module id = 1640
// module chunks = 0